import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";

// Philosophy section images in exact order
const PHILOSOPHY_IMAGES = {
  monje: "https://customer-assets.emergentagent.com/job_export-to-wp/artifacts/94ehdpmy_formato%20largo%20monje.jpg",
  vision: "https://customer-assets.emergentagent.com/job_export-to-wp/artifacts/b30j4ixk_formato%20largo%20vision.jpg",
  abu: "https://customer-assets.emergentagent.com/job_export-to-wp/artifacts/i0ti6t02_formato%20largo%20abu.jpg",
};

const FilosofiaPage = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen">
      {/* Section 1: Main Statement - Monje */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={PHILOSOPHY_IMAGES.monje}
            alt={`${t.filosofia.section1Title} ${t.filosofia.section1Highlight}`}
            className="w-full h-full object-cover"
            loading="eager"
          />
          {/* Subtle overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-background/60 via-background/30 to-transparent" />
          {/* Film grain texture */}
          <div className="absolute inset-0 grain-overlay opacity-[0.04]" />
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-32">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
            className="max-w-xl"
          >
            {/* Main Text - Single unified statement */}
            <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">
              <span className="text-foreground">{t.filosofia.section1Title} </span>
              <span className="text-primary">{t.filosofia.section1Highlight}</span>
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Section 2: Narrativa - Vision (girl/one eye) */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={PHILOSOPHY_IMAGES.vision}
            alt={t.filosofia.section2Title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* Subtle overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-background/70 via-background/40 to-transparent" />
          {/* Film grain texture */}
          <div className="absolute inset-0 grain-overlay opacity-[0.04]" />
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-32">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
            className="max-w-xl"
          >
            {/* Key Phrase - Stronger visual emphasis */}
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal leading-tight text-foreground mb-8">
              {t.filosofia.section2Title}
            </h2>
            
            {/* Supporting text */}
            <p className="text-base lg:text-lg text-foreground/80 leading-relaxed font-light">
              {t.filosofia.section2Text}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Section 3: IA - Abu (third image) */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={PHILOSOPHY_IMAGES.abu}
            alt={t.filosofia.section3Title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* Subtle overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-background/70 via-background/40 to-transparent" />
          {/* Film grain texture */}
          <div className="absolute inset-0 grain-overlay opacity-[0.04]" />
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 py-32">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
            className="max-w-xl"
          >
            {/* Key Phrase - Stronger visual emphasis */}
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal leading-tight text-foreground mb-8">
              {t.filosofia.section3Title}
            </h2>
            
            {/* Supporting text - Less emphasis */}
            <p className="text-base lg:text-lg text-foreground/70 leading-relaxed font-light">
              {t.filosofia.section3Text}
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default FilosofiaPage;
